/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  collectExtraKeys as collectExtraKeys$,
  safeParse,
} from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListEvalScheduleRunsQueryParamStatus = {
  Queued: "queued",
  InProgress: "in_progress",
  Finalizing: "finalizing",
  Completed: "completed",
  Failed: "failed",
  Cancelling: "cancelling",
  Cancelled: "cancelled",
} as const;
export type ListEvalScheduleRunsQueryParamStatus = ClosedEnum<
  typeof ListEvalScheduleRunsQueryParamStatus
>;

export type ListEvalScheduleRunsRequest = {
  scheduleId: string;
  after?: string | undefined;
  limit?: number | undefined;
  suiteId?: string | undefined;
  suiteVersion?: number | undefined;
  status?: ListEvalScheduleRunsQueryParamStatus | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type ListEvalScheduleRunsStop = string | Array<string>;

export const ListEvalScheduleRunsTruncation = {
  Auto: "auto",
  Disabled: "disabled",
} as const;
export type ListEvalScheduleRunsTruncation = ClosedEnum<
  typeof ListEvalScheduleRunsTruncation
>;

export const ListEvalScheduleRunsServiceTier = {
  Auto: "auto",
  Default: "default",
  Flex: "flex",
  Priority: "priority",
} as const;
export type ListEvalScheduleRunsServiceTier = ClosedEnum<
  typeof ListEvalScheduleRunsServiceTier
>;

export type ListEvalScheduleRunsPrefillThink = boolean | string;

export type ListEvalScheduleRunsGeneration = {
  instructions?: string | undefined;
  temperature?: number | undefined;
  topP?: number | undefined;
  maxOutputTokens?: number | undefined;
  /**
   * lm-eval alias for max_output_tokens.
   */
  maxGenToks?: number | undefined;
  stop?: string | Array<string> | undefined;
  /**
   * lm-eval generate_until stop sequences.
   */
  until?: Array<string> | undefined;
  maxToolCalls?: number | undefined;
  reasoning?: any | undefined;
  text?: any | undefined;
  tools?: Array<any | null> | undefined;
  toolChoice?: any | undefined;
  parallelToolCalls?: boolean | undefined;
  truncation?: ListEvalScheduleRunsTruncation | undefined;
  serviceTier?: ListEvalScheduleRunsServiceTier | undefined;
  presencePenalty?: number | undefined;
  frequencyPenalty?: number | undefined;
  topK?: number | undefined;
  minP?: number | undefined;
  repetitionPenalty?: number | undefined;
  doSample?: boolean | undefined;
  extraBody?: { [k: string]: any } | undefined;
  chatTemplateKwargs?: { [k: string]: any } | undefined;
  prefillThink?: boolean | string | undefined;
  useCache?: boolean | undefined;
  timeoutSeconds?: number | undefined;
  maxRetries?: number | undefined;
  maxEmptyRetries?: number | undefined;
  additionalProperties?: { [k: string]: any } | undefined;
};

export type ListEvalScheduleRunsRequestCounts = {
  total: number;
  completed: number;
  failed: number;
};

export type ListEvalScheduleRunsData = {
  id: string;
  object: "eval.run";
  suiteId: string;
  suiteVersion: number;
  suiteVersionId: string;
  /**
   * The org that owns this run.
   */
  orgId: string;
  /**
   * The team that owns this run.
   */
  teamId: string;
  status: components.EvalRunStatus;
  models: Array<string>;
  taskIds: Array<string> | null;
  judgeModel: string | null;
  embeddingModel: string | null;
  generation: ListEvalScheduleRunsGeneration;
  requestCounts: ListEvalScheduleRunsRequestCounts;
  metrics: { [k: string]: any } | null;
  error: { [k: string]: any } | null;
  artifactFileIds: Array<string>;
  metadata: { [k: string]: string };
  createdAt: number;
  startedAt: number | null;
  completedAt: number | null;
  cancelledAt: number | null;
  failedAt: number | null;
};

/**
 * OK
 */
export type ListEvalScheduleRunsResponseBody = {
  object: "list";
  data: Array<ListEvalScheduleRunsData>;
  firstId?: string | undefined;
  lastId?: string | undefined;
  hasMore: boolean;
};

/** @internal */
export const ListEvalScheduleRunsQueryParamStatus$inboundSchema:
  z.ZodNativeEnum<typeof ListEvalScheduleRunsQueryParamStatus> = z.nativeEnum(
    ListEvalScheduleRunsQueryParamStatus,
  );
/** @internal */
export const ListEvalScheduleRunsQueryParamStatus$outboundSchema:
  z.ZodNativeEnum<typeof ListEvalScheduleRunsQueryParamStatus> =
    ListEvalScheduleRunsQueryParamStatus$inboundSchema;

/** @internal */
export const ListEvalScheduleRunsRequest$inboundSchema: z.ZodType<
  ListEvalScheduleRunsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schedule_id: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(20),
  suite_id: z.string().optional(),
  suite_version: z.number().int().optional(),
  status: ListEvalScheduleRunsQueryParamStatus$inboundSchema.optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "schedule_id": "scheduleId",
    "suite_id": "suiteId",
    "suite_version": "suiteVersion",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListEvalScheduleRunsRequest$Outbound = {
  schedule_id: string;
  after?: string | undefined;
  limit: number;
  suite_id?: string | undefined;
  suite_version?: number | undefined;
  status?: string | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListEvalScheduleRunsRequest$outboundSchema: z.ZodType<
  ListEvalScheduleRunsRequest$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsRequest
> = z.object({
  scheduleId: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(20),
  suiteId: z.string().optional(),
  suiteVersion: z.number().int().optional(),
  status: ListEvalScheduleRunsQueryParamStatus$outboundSchema.optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    scheduleId: "schedule_id",
    suiteId: "suite_id",
    suiteVersion: "suite_version",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listEvalScheduleRunsRequestToJSON(
  listEvalScheduleRunsRequest: ListEvalScheduleRunsRequest,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsRequest$outboundSchema.parse(
      listEvalScheduleRunsRequest,
    ),
  );
}
export function listEvalScheduleRunsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsRequest' from JSON`,
  );
}

/** @internal */
export const ListEvalScheduleRunsStop$inboundSchema: z.ZodType<
  ListEvalScheduleRunsStop,
  z.ZodTypeDef,
  unknown
> = z.union([z.string(), z.array(z.string())]);
/** @internal */
export type ListEvalScheduleRunsStop$Outbound = string | Array<string>;

/** @internal */
export const ListEvalScheduleRunsStop$outboundSchema: z.ZodType<
  ListEvalScheduleRunsStop$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsStop
> = z.union([z.string(), z.array(z.string())]);

export function listEvalScheduleRunsStopToJSON(
  listEvalScheduleRunsStop: ListEvalScheduleRunsStop,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsStop$outboundSchema.parse(listEvalScheduleRunsStop),
  );
}
export function listEvalScheduleRunsStopFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsStop, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsStop$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsStop' from JSON`,
  );
}

/** @internal */
export const ListEvalScheduleRunsTruncation$inboundSchema: z.ZodNativeEnum<
  typeof ListEvalScheduleRunsTruncation
> = z.nativeEnum(ListEvalScheduleRunsTruncation);
/** @internal */
export const ListEvalScheduleRunsTruncation$outboundSchema: z.ZodNativeEnum<
  typeof ListEvalScheduleRunsTruncation
> = ListEvalScheduleRunsTruncation$inboundSchema;

/** @internal */
export const ListEvalScheduleRunsServiceTier$inboundSchema: z.ZodNativeEnum<
  typeof ListEvalScheduleRunsServiceTier
> = z.nativeEnum(ListEvalScheduleRunsServiceTier);
/** @internal */
export const ListEvalScheduleRunsServiceTier$outboundSchema: z.ZodNativeEnum<
  typeof ListEvalScheduleRunsServiceTier
> = ListEvalScheduleRunsServiceTier$inboundSchema;

/** @internal */
export const ListEvalScheduleRunsPrefillThink$inboundSchema: z.ZodType<
  ListEvalScheduleRunsPrefillThink,
  z.ZodTypeDef,
  unknown
> = z.union([z.boolean(), z.string()]);
/** @internal */
export type ListEvalScheduleRunsPrefillThink$Outbound = boolean | string;

/** @internal */
export const ListEvalScheduleRunsPrefillThink$outboundSchema: z.ZodType<
  ListEvalScheduleRunsPrefillThink$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsPrefillThink
> = z.union([z.boolean(), z.string()]);

export function listEvalScheduleRunsPrefillThinkToJSON(
  listEvalScheduleRunsPrefillThink: ListEvalScheduleRunsPrefillThink,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsPrefillThink$outboundSchema.parse(
      listEvalScheduleRunsPrefillThink,
    ),
  );
}
export function listEvalScheduleRunsPrefillThinkFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsPrefillThink, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsPrefillThink$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsPrefillThink' from JSON`,
  );
}

/** @internal */
export const ListEvalScheduleRunsGeneration$inboundSchema: z.ZodType<
  ListEvalScheduleRunsGeneration,
  z.ZodTypeDef,
  unknown
> = collectExtraKeys$(
  z.object({
    instructions: z.string().optional(),
    temperature: z.number().optional(),
    top_p: z.number().optional(),
    max_output_tokens: z.number().int().optional(),
    max_gen_toks: z.number().int().optional(),
    stop: z.union([z.string(), z.array(z.string())]).optional(),
    until: z.array(z.string()).optional(),
    max_tool_calls: z.number().int().optional(),
    reasoning: z.any().optional(),
    text: z.any().optional(),
    tools: z.array(z.nullable(z.any())).optional(),
    tool_choice: z.any().optional(),
    parallel_tool_calls: z.boolean().optional(),
    truncation: ListEvalScheduleRunsTruncation$inboundSchema.optional(),
    service_tier: ListEvalScheduleRunsServiceTier$inboundSchema.optional(),
    presence_penalty: z.number().optional(),
    frequency_penalty: z.number().optional(),
    top_k: z.number().int().optional(),
    min_p: z.number().optional(),
    repetition_penalty: z.number().optional(),
    do_sample: z.boolean().optional(),
    extra_body: z.record(z.any()).optional(),
    chat_template_kwargs: z.record(z.any()).optional(),
    prefill_think: z.union([z.boolean(), z.string()]).optional(),
    use_cache: z.boolean().optional(),
    timeout_seconds: z.number().int().optional(),
    max_retries: z.number().int().optional(),
    max_empty_retries: z.number().int().optional(),
  }).catchall(z.any()),
  "additionalProperties",
  true,
).transform((v) => {
  return remap$(v, {
    "top_p": "topP",
    "max_output_tokens": "maxOutputTokens",
    "max_gen_toks": "maxGenToks",
    "max_tool_calls": "maxToolCalls",
    "tool_choice": "toolChoice",
    "parallel_tool_calls": "parallelToolCalls",
    "service_tier": "serviceTier",
    "presence_penalty": "presencePenalty",
    "frequency_penalty": "frequencyPenalty",
    "top_k": "topK",
    "min_p": "minP",
    "repetition_penalty": "repetitionPenalty",
    "do_sample": "doSample",
    "extra_body": "extraBody",
    "chat_template_kwargs": "chatTemplateKwargs",
    "prefill_think": "prefillThink",
    "use_cache": "useCache",
    "timeout_seconds": "timeoutSeconds",
    "max_retries": "maxRetries",
    "max_empty_retries": "maxEmptyRetries",
  });
});
/** @internal */
export type ListEvalScheduleRunsGeneration$Outbound = {
  instructions?: string | undefined;
  temperature?: number | undefined;
  top_p?: number | undefined;
  max_output_tokens?: number | undefined;
  max_gen_toks?: number | undefined;
  stop?: string | Array<string> | undefined;
  until?: Array<string> | undefined;
  max_tool_calls?: number | undefined;
  reasoning?: any | undefined;
  text?: any | undefined;
  tools?: Array<any | null> | undefined;
  tool_choice?: any | undefined;
  parallel_tool_calls?: boolean | undefined;
  truncation?: string | undefined;
  service_tier?: string | undefined;
  presence_penalty?: number | undefined;
  frequency_penalty?: number | undefined;
  top_k?: number | undefined;
  min_p?: number | undefined;
  repetition_penalty?: number | undefined;
  do_sample?: boolean | undefined;
  extra_body?: { [k: string]: any } | undefined;
  chat_template_kwargs?: { [k: string]: any } | undefined;
  prefill_think?: boolean | string | undefined;
  use_cache?: boolean | undefined;
  timeout_seconds?: number | undefined;
  max_retries?: number | undefined;
  max_empty_retries?: number | undefined;
  [additionalProperties: string]: unknown;
};

/** @internal */
export const ListEvalScheduleRunsGeneration$outboundSchema: z.ZodType<
  ListEvalScheduleRunsGeneration$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsGeneration
> = z.object({
  instructions: z.string().optional(),
  temperature: z.number().optional(),
  topP: z.number().optional(),
  maxOutputTokens: z.number().int().optional(),
  maxGenToks: z.number().int().optional(),
  stop: z.union([z.string(), z.array(z.string())]).optional(),
  until: z.array(z.string()).optional(),
  maxToolCalls: z.number().int().optional(),
  reasoning: z.any().optional(),
  text: z.any().optional(),
  tools: z.array(z.nullable(z.any())).optional(),
  toolChoice: z.any().optional(),
  parallelToolCalls: z.boolean().optional(),
  truncation: ListEvalScheduleRunsTruncation$outboundSchema.optional(),
  serviceTier: ListEvalScheduleRunsServiceTier$outboundSchema.optional(),
  presencePenalty: z.number().optional(),
  frequencyPenalty: z.number().optional(),
  topK: z.number().int().optional(),
  minP: z.number().optional(),
  repetitionPenalty: z.number().optional(),
  doSample: z.boolean().optional(),
  extraBody: z.record(z.any()).optional(),
  chatTemplateKwargs: z.record(z.any()).optional(),
  prefillThink: z.union([z.boolean(), z.string()]).optional(),
  useCache: z.boolean().optional(),
  timeoutSeconds: z.number().int().optional(),
  maxRetries: z.number().int().optional(),
  maxEmptyRetries: z.number().int().optional(),
  additionalProperties: z.record(z.any()).optional(),
}).transform((v) => {
  return {
    ...v.additionalProperties,
    ...remap$(v, {
      topP: "top_p",
      maxOutputTokens: "max_output_tokens",
      maxGenToks: "max_gen_toks",
      maxToolCalls: "max_tool_calls",
      toolChoice: "tool_choice",
      parallelToolCalls: "parallel_tool_calls",
      serviceTier: "service_tier",
      presencePenalty: "presence_penalty",
      frequencyPenalty: "frequency_penalty",
      topK: "top_k",
      minP: "min_p",
      repetitionPenalty: "repetition_penalty",
      doSample: "do_sample",
      extraBody: "extra_body",
      chatTemplateKwargs: "chat_template_kwargs",
      prefillThink: "prefill_think",
      useCache: "use_cache",
      timeoutSeconds: "timeout_seconds",
      maxRetries: "max_retries",
      maxEmptyRetries: "max_empty_retries",
      additionalProperties: null,
    }),
  };
});

export function listEvalScheduleRunsGenerationToJSON(
  listEvalScheduleRunsGeneration: ListEvalScheduleRunsGeneration,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsGeneration$outboundSchema.parse(
      listEvalScheduleRunsGeneration,
    ),
  );
}
export function listEvalScheduleRunsGenerationFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsGeneration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsGeneration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsGeneration' from JSON`,
  );
}

/** @internal */
export const ListEvalScheduleRunsRequestCounts$inboundSchema: z.ZodType<
  ListEvalScheduleRunsRequestCounts,
  z.ZodTypeDef,
  unknown
> = z.object({
  total: z.number().int(),
  completed: z.number().int(),
  failed: z.number().int(),
});
/** @internal */
export type ListEvalScheduleRunsRequestCounts$Outbound = {
  total: number;
  completed: number;
  failed: number;
};

/** @internal */
export const ListEvalScheduleRunsRequestCounts$outboundSchema: z.ZodType<
  ListEvalScheduleRunsRequestCounts$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsRequestCounts
> = z.object({
  total: z.number().int(),
  completed: z.number().int(),
  failed: z.number().int(),
});

export function listEvalScheduleRunsRequestCountsToJSON(
  listEvalScheduleRunsRequestCounts: ListEvalScheduleRunsRequestCounts,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsRequestCounts$outboundSchema.parse(
      listEvalScheduleRunsRequestCounts,
    ),
  );
}
export function listEvalScheduleRunsRequestCountsFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsRequestCounts, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsRequestCounts$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsRequestCounts' from JSON`,
  );
}

/** @internal */
export const ListEvalScheduleRunsData$inboundSchema: z.ZodType<
  ListEvalScheduleRunsData,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.run"),
  suite_id: z.string(),
  suite_version: z.number().int(),
  suite_version_id: z.string(),
  org_id: z.string(),
  team_id: z.string(),
  status: components.EvalRunStatus$inboundSchema,
  models: z.array(z.string()),
  task_ids: z.nullable(z.array(z.string())),
  judge_model: z.nullable(z.string()),
  embedding_model: z.nullable(z.string()),
  generation: z.lazy(() => ListEvalScheduleRunsGeneration$inboundSchema),
  request_counts: z.lazy(() => ListEvalScheduleRunsRequestCounts$inboundSchema),
  metrics: z.nullable(z.record(z.any())),
  error: z.nullable(z.record(z.any())),
  artifact_file_ids: z.array(z.string()),
  metadata: z.record(z.string()),
  created_at: z.number().int(),
  started_at: z.nullable(z.number().int()),
  completed_at: z.nullable(z.number().int()),
  cancelled_at: z.nullable(z.number().int()),
  failed_at: z.nullable(z.number().int()),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "suite_version": "suiteVersion",
    "suite_version_id": "suiteVersionId",
    "org_id": "orgId",
    "team_id": "teamId",
    "task_ids": "taskIds",
    "judge_model": "judgeModel",
    "embedding_model": "embeddingModel",
    "request_counts": "requestCounts",
    "artifact_file_ids": "artifactFileIds",
    "created_at": "createdAt",
    "started_at": "startedAt",
    "completed_at": "completedAt",
    "cancelled_at": "cancelledAt",
    "failed_at": "failedAt",
  });
});
/** @internal */
export type ListEvalScheduleRunsData$Outbound = {
  id: string;
  object: "eval.run";
  suite_id: string;
  suite_version: number;
  suite_version_id: string;
  org_id: string;
  team_id: string;
  status: string;
  models: Array<string>;
  task_ids: Array<string> | null;
  judge_model: string | null;
  embedding_model: string | null;
  generation: ListEvalScheduleRunsGeneration$Outbound;
  request_counts: ListEvalScheduleRunsRequestCounts$Outbound;
  metrics: { [k: string]: any } | null;
  error: { [k: string]: any } | null;
  artifact_file_ids: Array<string>;
  metadata: { [k: string]: string };
  created_at: number;
  started_at: number | null;
  completed_at: number | null;
  cancelled_at: number | null;
  failed_at: number | null;
};

/** @internal */
export const ListEvalScheduleRunsData$outboundSchema: z.ZodType<
  ListEvalScheduleRunsData$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsData
> = z.object({
  id: z.string(),
  object: z.literal("eval.run"),
  suiteId: z.string(),
  suiteVersion: z.number().int(),
  suiteVersionId: z.string(),
  orgId: z.string(),
  teamId: z.string(),
  status: components.EvalRunStatus$outboundSchema,
  models: z.array(z.string()),
  taskIds: z.nullable(z.array(z.string())),
  judgeModel: z.nullable(z.string()),
  embeddingModel: z.nullable(z.string()),
  generation: z.lazy(() => ListEvalScheduleRunsGeneration$outboundSchema),
  requestCounts: z.lazy(() => ListEvalScheduleRunsRequestCounts$outboundSchema),
  metrics: z.nullable(z.record(z.any())),
  error: z.nullable(z.record(z.any())),
  artifactFileIds: z.array(z.string()),
  metadata: z.record(z.string()),
  createdAt: z.number().int(),
  startedAt: z.nullable(z.number().int()),
  completedAt: z.nullable(z.number().int()),
  cancelledAt: z.nullable(z.number().int()),
  failedAt: z.nullable(z.number().int()),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    suiteVersion: "suite_version",
    suiteVersionId: "suite_version_id",
    orgId: "org_id",
    teamId: "team_id",
    taskIds: "task_ids",
    judgeModel: "judge_model",
    embeddingModel: "embedding_model",
    requestCounts: "request_counts",
    artifactFileIds: "artifact_file_ids",
    createdAt: "created_at",
    startedAt: "started_at",
    completedAt: "completed_at",
    cancelledAt: "cancelled_at",
    failedAt: "failed_at",
  });
});

export function listEvalScheduleRunsDataToJSON(
  listEvalScheduleRunsData: ListEvalScheduleRunsData,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsData$outboundSchema.parse(listEvalScheduleRunsData),
  );
}
export function listEvalScheduleRunsDataFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsData' from JSON`,
  );
}

/** @internal */
export const ListEvalScheduleRunsResponseBody$inboundSchema: z.ZodType<
  ListEvalScheduleRunsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListEvalScheduleRunsData$inboundSchema)),
  first_id: z.string().optional(),
  last_id: z.string().optional(),
  has_more: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    "first_id": "firstId",
    "last_id": "lastId",
    "has_more": "hasMore",
  });
});
/** @internal */
export type ListEvalScheduleRunsResponseBody$Outbound = {
  object: "list";
  data: Array<ListEvalScheduleRunsData$Outbound>;
  first_id?: string | undefined;
  last_id?: string | undefined;
  has_more: boolean;
};

/** @internal */
export const ListEvalScheduleRunsResponseBody$outboundSchema: z.ZodType<
  ListEvalScheduleRunsResponseBody$Outbound,
  z.ZodTypeDef,
  ListEvalScheduleRunsResponseBody
> = z.object({
  object: z.literal("list"),
  data: z.array(z.lazy(() => ListEvalScheduleRunsData$outboundSchema)),
  firstId: z.string().optional(),
  lastId: z.string().optional(),
  hasMore: z.boolean(),
}).transform((v) => {
  return remap$(v, {
    firstId: "first_id",
    lastId: "last_id",
    hasMore: "has_more",
  });
});

export function listEvalScheduleRunsResponseBodyToJSON(
  listEvalScheduleRunsResponseBody: ListEvalScheduleRunsResponseBody,
): string {
  return JSON.stringify(
    ListEvalScheduleRunsResponseBody$outboundSchema.parse(
      listEvalScheduleRunsResponseBody,
    ),
  );
}
export function listEvalScheduleRunsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalScheduleRunsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalScheduleRunsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalScheduleRunsResponseBody' from JSON`,
  );
}
